import React from "react";
import { ReactComponent as Settings } from "./settings.svg";
import { ReactComponent as InsertBefore } from "./insert-before.svg";
import { ReactComponent as InsertAfter } from "./insert-after.svg";
import { ReactComponent as Delete } from "./delete.svg";
import { ReactComponent as Duplicate } from "./duplicate.svg";
import { ReactComponent as GeneralSettings } from "./general-settings.svg";
import { ReactComponent as Style } from "./style.svg";
// Bulb
import { ReactComponent as Bulb } from "./bulb.svg";
// SEO
import { ReactComponent as SEO } from "./seo.svg";
// Plane
import { ReactComponent as Plane } from "./plane.svg";
// Eyes
import { ReactComponent as Eyes } from "./eyes.svg";
// Link
import { ReactComponent as Link } from "./link.svg";
// Elipsis
import { ReactComponent as Elipsis } from "./elipsis.svg";
// Keyboard
import { ReactComponent as Keyboard } from "./keyboard.svg";
// Info
import { ReactComponent as Info } from "./info.svg";
// Crosshair
import { ReactComponent as Crosshair } from "./crosshair.svg";
// Folder
import { ReactComponent as Folder } from "./folder.svg";
// Folder Solid
import { ReactComponent as FolderSolid } from "./folder-solid.svg";
// new tab
import { ReactComponent as NewTab } from "./new-tab.svg";
// migration
import { ReactComponent as Migration } from "./migration.svg";
// question
import { ReactComponent as Question } from "./question.svg";
// comment
import { ReactComponent as Comment } from "./comment.svg";
// AI
import { ReactComponent as AI } from "./ai.svg";

export const IconPack = {
  Settings,
  InsertBefore,
  InsertAfter,
  Delete,
  Duplicate,
  GeneralSettings,
  Style,
  Bulb,
  SEO,
  Plane,
  Eyes,
  Link,
  Elipsis,
  Keyboard,
  Info,
  Crosshair,
  Folder,
  FolderSolid,
  NewTab,
  Migration,
  Question,
  Comment,
  AI,
  Question,
};

export const IconsRenderer = ({ name, ...rest }) => {
  const Icon = IconPack[name];
  if (!Icon) return <></>;
  return <Icon {...rest} />;
};
